import HttpService from './HttpService';

const BASE_URL = 'product/';

export default class ProductService {
  constructor() {
    this.httpService = new HttpService();
  }

  async GetAllProducts() {
    return this.httpService.Request(`${BASE_URL}all`, {
      method: 'GET',
    });
  }

  async GetProduct(id) {
    return this.httpService.Request(`${BASE_URL}${id}`, {
      method: 'GET',
    });
  }

  GetProductImageUrl(id) {
    const url = `${process.env.REACT_APP_API_URL}/${BASE_URL}${id}/image`;
    return url;
  }
}
